<template>
  <div>
    <div 
      :id="textDivId"
      ref="textDiv"
      :style="ellipsisStyle"
    >
      <slot class="skiptranslate"></slot>
    </div>
    <!-- Remove when upgrading to Bootstrap5 because it doesnt work -->
    <!-- <b-popover v-if="isOverflowing" :target="textDiv" triggers="hover" placement="bottom" v-html="popoverText"></b-popover> -->
  </div>
</template>
<script>
import RetryWorker from '../utils/RetryWorker'

export default {
  props: {
    lines: {
      type : Number,
      default : 1
    },
  },
  data(){
    return {
      // Used for tracking screen changes
      verticalBuffer : 2,
      textDiv : null,
      isOverflowing : false,
      windowsStates : {},
    }
  },
  mounted() {
    this.textDiv = this.$refs.textDiv
    window.addEventListener('resize', this.handleResize)
    
    var self = this
    new RetryWorker(10, 2000, function(){
      return new Promise((resolve, reject) => {
        var windowStates = self.handleResize()
        if(windowStates && windowStates.scrollWidth > 0 && windowsStates.clientWidth > 0){
          resolve(true)
        }
        else{
          reject()
        }
      })
    }).doWork()
  },
  computed : {
    textDivId(){
      var popoverText = this.popoverText
      if(popoverText){
        popoverText = popoverText.split(' ').join('')
        popoverText = 'textDiv-' + popoverText.substring(0,10) 
      }
      return popoverText
    },
    textDivFontSizePixels(){
      var fontSize
      if(this.textDivId){
        var textDiv = document.getElementById(this.textDivId)
        if(textDiv){
          var textDivCss = window.getComputedStyle(textDiv);
          fontSize = textDivCss['font-size']
        }
      }
      if(!fontSize){
        fontSize = "16px" // 1em
      }
      return fontSize
    },
    textDivHeightPixels(){
      var height
      if(this.textDivFontSizePixels && this.lines){
        var fontSize = this.textDivFontSizePixels.replace('px', '')
        fontSize = parseInt(fontSize)
        height = fontSize * this.lines
        height += this.verticalBuffer
        height = height + "px"
      }
      return height
    },
    popoverText(){
      var text
      for (let i = 0; i < this.$slots.default.length; i++) {
        const element = this.$slots.default[i]
        if(element.text){
          text = element.text.trim()
          break
        }
      }
      return text
    },
    ellipsisStyle(){
      const style = {
        display: "block",
        display: "-webkit-box",
        margin:' 0 auto',
        // height : this.textDivHeightPixels, // --- Removing unnecessary style because container wraps content anyway
        "font-size" : this.textDivFontSizePixels,
        "line-height": 1,
        '-webkit-line-clamp': this.lines,
        '-webkit-box-orient': 'vertical',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      }
      if(this.isOverflowing){
        style.height = this.textDivFontSizePixels*this.lines
      }
      return style
    }
  },
  methods : {
    handleResize(event) {
      var scrollWidth = this.textDiv.offsetWidth
      var clientWidth = this.textDiv.clientWidth
      var scrollHeight = this.textDiv.scrollHeight
      var clientHeight = this.textDiv.clientHeight

      this.isOverflowing = scrollHeight > (clientHeight+this.verticalBuffer) || scrollWidth > clientWidth;
      const data = { scrollWidth, clientWidth, scrollHeight, clientHeight }
      this.windowsStates = data
      return data;
    }
  }
}
</script>